module.exports = __webpack_public_path__ + "img/cart-state-arrow-icon.950615ed.svg";